var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.view)?_c('div',{staticClass:"progress-bar-top"},[_c('b-progress',{attrs:{"value":_vm.progress,"max":"100","height":"2px","variant":_vm.variant}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }